import * as Sentry from "@sentry/react";
import { env } from "@/shared/config/env";

type TanstackRouter = Parameters<typeof Sentry.tanstackRouterBrowserTracingIntegration>[0];

// Error monitoring (+ TanStack Router navigation tracing). No-op in dev / e2e
// or when no DSN is configured, so local runs never report.
export const initSentry = (router: TanstackRouter): void => {
  if (env.VITE_SENTRY_DSN === "" || env.DEV || env.VITE_E2E) return;

  Sentry.init({
    dsn: env.VITE_SENTRY_DSN,
    environment: env.VITE_APP_ENV,
    integrations: [Sentry.tanstackRouterBrowserTracingIntegration(router)],
    // Sample 10% of transactions for performance; all errors are always sent.
    tracesSampleRate: 0.1,
    sendDefaultPii: false,
  });
};
